export default {
  name: "ChevronUp",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M6.71 20.71A1 1 0 1 1 5.3 19.3l10-10a1 1 0 0 1 1.41 0l10 10a1 1 0 1 1-1.41 1.41l-9.3-9.3-9.29 9.3z",
  },
}
